import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import {
  AspectRatio,
  Stack,
  Box,
  Heading,
  Text,
  Image
} from '@chakra-ui/react';
import Button from '@components/atoms/Button';
import { ArrowRightIcon } from '@components/atoms/icons';
import { localeRoot } from '@helpers/environment';
import { appendIfValid } from '@helpers/linkResolver';

const LinkComponent = ({ to, children, entryLocale, ...props }) => {
  return (
    <GatsbyLink to={to} {...props}>
      {children}
    </GatsbyLink>
  );
};

const Tease = ({ title, text, image, cta, entryLocale }) => {
  return (
    <Stack
      as={cta?.link ? LinkComponent : null}
      to={cta?.link}
      entryLocale={entryLocale}
      className="button-hover"
      direction={{ base: `column`, md: `row-reverse` }}
      justify="left"
      spacing={{ base: 8, md: 0 }}
      width="100%">
      {image && image.formats.medium && (
        <Box width={{ md: `18rem` }} flex="0 0 auto">
          <AspectRatio
            ratio={3 / 2}
            overflow="hidden"
            borderRadius="xs"
            borderBottomRightRadius="md">
            <Image
              src={`${appendIfValid(localeRoot, `/`)}${
                image.formats.medium.url
              }`}
              alt={image.alternativeText}
            />
          </AspectRatio>
        </Box>
      )}
      <Box width={{ md: `calc(100% - 18rem)` }} pr={{ md: 12 }}>
        {title && (
          <Heading
            size="lg"
            color="secondary.pink"
            textDecoration="underline"
            textUnderlineOffset="3px"
            textDecorationThickness="2px">
            {title}
          </Heading>
        )}
        {text && <Text>{text}</Text>}
        {cta?.link && (
          <Button
            as="span"
            variant="secondary"
            iconBorderColor="primary.froneri-blue"
            rightIcon={<ArrowRightIcon />}>
            {cta.title}
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default Tease;
